import type { CompoundEntityRef, Entity } from '@backstage/catalog-model';
import { getCompoundEntityRef } from '@backstage/catalog-model';
import { isEntity } from '@internal/backstage-plugin-api-catalog-common';

export const getEntityCatalogLink = (
  entity: Entity | CompoundEntityRef,
  subPath?: string | null,
) => {
  const ref = isEntity(entity) ? getCompoundEntityRef(entity) : entity;
  let link = `/catalog/${ref.namespace}/${ref.kind.toLowerCase()}/${ref.name}`;
  if (subPath) {
    link += `/${subPath}`;
  }
  return link;
};
